/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { TimeClockIdleViewService } from '../../view/time-clock-idle.view-service';
import { ContainerModel } from '@typescript-kit/view';

@Component({
  selector: 'app-time-clock-idle',
  templateUrl: './time-clock-idle.component.html',
  styleUrls: ['./time-clock-idle.component.scss'],
  providers: [TimeClockIdleViewService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeClockIdleComponent implements OnInit, OnDestroy {

  constructor(private readonly viewService: TimeClockIdleViewService) { }

  ngOnInit() {
    this.viewService.initialize();
  }

  ngOnDestroy(): void {
    this.viewService.finalize();
}

  get model(): ContainerModel {
    return this.viewService.componentModel;
  }

}
